import React from 'react';
import { Cookie } from 'lucide-react';
import { openCookieSettings } from './CookieConsentBanner';

/**
 * Tiny re-open trigger for the cookie consent banner. Lets visitors
 * revoke/modify consent at any time as required by GDPR art. 7.3
 * ("the right to withdraw consent must be as easy as giving it").
 *
 * Variants:
 *   - 'icon'    (default) — bare cookie icon, no text, no fixed
 *                positioning. Designed to live inline in an existing
 *                footer next to privacy/T&C links.
 *   - 'inline'  — icon + label text "Gestisci cookie", still inline,
 *                used where there is room and we want a clearer CTA.
 */
export default function CookieFooterLink({ variant = 'icon', className = '', testid = 'manage-cookies-link' }) {
  if (variant === 'inline') {
    return (
      <button
        type="button"
        onClick={openCookieSettings}
        data-testid={testid}
        className={`inline-flex items-center gap-1 text-xs text-current opacity-60 hover:opacity-100 transition-opacity ${className}`}
      >
        <Cookie size={11} /> Gestisci cookie
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={openCookieSettings}
      aria-label="Gestisci preferenze cookie"
      title="Gestisci preferenze cookie"
      data-testid={testid}
      className={`inline-flex items-center justify-center w-6 h-6 rounded-full opacity-50 hover:opacity-100 transition-opacity ${className}`}
    >
      <Cookie size={13} />
    </button>
  );
}
